import { faTriangleExclamation, faCheck } from "@fortawesome/free-solid-svg-icons";

export const COURSE_DESCRIPTION_ROWS = 4;
export const MODULE_DESCRIPTION_ROWS = 3;

export const PUBLISH_STATUS = Object.freeze({
	UNPUBLISHED: 0,
	PUBLISHED: 1,
});

export const PUBLISH_STATUS_META = {
	[PUBLISH_STATUS.UNPUBLISHED]: {
		label: "Unpublished",
		icon: faTriangleExclamation,
		color: "#F68B1F",
		className: "is-unpublished",
	},
	[PUBLISH_STATUS.PUBLISHED]: {
		label: "Published",
		icon: faCheck,
		color: "#1ea324",
		className: "is-published",
	},
};

export const getPublishStatusMeta = (status) =>
	PUBLISH_STATUS_META[status] ?? {
		label: `Unknown (${status})`,
		icon: null,
		color: "#999",
		className: "is-unknown"
	};

export const ContentType = Object.freeze({
	None: 0,
	Device: 1
});

export const EDIT_SCOPE = Object.freeze({
	COURSE: "Course",
	MODULE: "Module",
	SUBMODULE: "Submodule"
});

export const EDIT_FIELD = Object.freeze({
	NAME: "Name",
	DESCRIPTION: "Description",
	IMAGE_URL: "ImageUrl",
	POSITION: "Position",
	ACTIVE: "Active"
});